import React from "react";
import { Link } from "react-router-dom";
import Layout from "../../components/layout";
import { useTranslation } from "react-i18next";

const siteMetadata = {
  title: "Institutional License Terms - Designing Multi-Agent Systems",
  description:
    "License terms for institutional and university access to Designing Multi-Agent Systems.",
  author: "Victor Dibia",
  image: "/images/og-service.png",
  keywords: "license terms, university license, institutional license",
  twitterUsername: "@designingwithml",
};

const UniversityTermsPage: React.FC = () => {
  const { t } = useTranslation("home");

  return (
    <Layout
      meta={siteMetadata}
      title="License Terms"
      link="/university/terms"
    >
      <main className="py-8 max-w-3xl">
        <div className="mb-6">
          <Link
            to="/university"
            className="text-sm text-accent hover:underline"
          >
            &larr; {t("universityTerms.backToUniversity")}
          </Link>
        </div>

        <h1 className="text-3xl font-bold text-primary mb-2">
          {t("universityTerms.title")}
        </h1>
        <p className="text-sm text-tertiary mb-8">
          {t("universityTerms.lastUpdated")}
        </p>

        <div className="prose prose-sm max-w-none text-secondary space-y-6">
          {/* 1. Grant of License */}
          <section>
            <h2 className="text-lg font-semibold text-primary">
              {t("universityTerms.grantTitle")}
            </h2>
            <p>{t("universityTerms.grantBody")}</p>
          </section>

          {/* 2. Permitted Use */}
          <section>
            <h2 className="text-lg font-semibold text-primary">
              {t("universityTerms.permittedUseTitle")}
            </h2>
            <ul className="list-disc pl-5 space-y-1">
              <li>{t("universityTerms.permittedUse1")}</li>
              <li>{t("universityTerms.permittedUse2")}</li>
              <li>{t("universityTerms.permittedUse3")}</li>
            </ul>
          </section>

          {/* 3. Restrictions */}
          <section>
            <h2 className="text-lg font-semibold text-primary">
              {t("universityTerms.restrictionsTitle")}
            </h2>
            <ul className="list-disc pl-5 space-y-1">
              <li>{t("universityTerms.restriction1")}</li>
              <li>{t("universityTerms.restriction2")}</li>
              <li>{t("universityTerms.restriction3")}</li>
            </ul>
          </section>

          {/* 4. Watermarking */}
          <section>
            <h2 className="text-lg font-semibold text-primary">
              {t("universityTerms.watermarkTitle")}
            </h2>
            <p>{t("universityTerms.watermarkBody")}</p>
          </section>

          {/* 5. Updates */}
          <section>
            <h2 className="text-lg font-semibold text-primary">
              {t("universityTerms.updatesTitle")}
            </h2>
            <p>{t("universityTerms.updatesBody")}</p>
          </section>

          {/* 6. Payment */}
          <section>
            <h2 className="text-lg font-semibold text-primary">
              {t("universityTerms.paymentTitle")}
            </h2>
            <p>{t("universityTerms.paymentBody")}</p>
          </section>

          {/* 7. Termination */}
          <section>
            <h2 className="text-lg font-semibold text-primary">
              {t("universityTerms.terminationTitle")}
            </h2>
            <p>{t("universityTerms.terminationBody")}</p>
          </section>

          {/* 8. Contact */}
          <section>
            <h2 className="text-lg font-semibold text-primary">
              {t("universityTerms.contactTitle")}
            </h2>
            <p>
              {t("universityTerms.contactBody")}{" "}
              <a
                href="mailto:support@multiagentbook.com"
                className="text-accent hover:underline"
              >
                support@multiagentbook.com
              </a>
            </p>
          </section>
        </div>
      </main>
    </Layout>
  );
};

export default UniversityTermsPage;
